import { ENVIRONMENT } from "@daytrip/legacy-config";
import { retryQueryLink } from "@daytrip/trpc-client-utils";
import { loggerLink, httpLink } from "@trpc/client";
import superjson from "superjson";

import { FRESH_URL } from "../../config.management";

import { freshTrpcReact } from "./freshTrpcReact";

export const freshTrpcClient = freshTrpcReact.createClient({
    links: [
        retryQueryLink({
            attempts: 2, // allow 1 retry
        }),
        loggerLink({
            enabled: () => ENVIRONMENT !== "production",
        }),
        httpLink({
            transformer: superjson,
            url: FRESH_URL,
        }),
    ],
});
